import * as Loading from "@repoflow/components/loading";
import { useQuery } from "@apollo/client";
import { useEffect } from "react";

export const QueryContent = ({
  children: Children,
  query,
  variables,
  context,
}) => {
  const { loading, error, data, refetch } = useQuery(query, { variables });

  if (loading)
    return (
      <div className="mt-4">
        <Loading.Content />
      </div>
    );
  if (error) return `Error! ${error.message}`;

  const account = data.viewer.account;

  if (!account) {
    return null;
  }

  return (
    <Children
      account={account}
      variables={variables}
      query={query}
      refetch={refetch}
      context={context}
    />
  );
};
